export default function UniversalService() {
  const services = [
    {
      icon: 'ri-window-line',
      title: 'Châssis PVC, Alu & Bois',
      description: 'Réparation complète de tous types de châssis',
      features: ['Mécanismes', 'Joints', 'Réglages']
    },
    {
      icon: 'ri-door-line',
      title: 'Portes Coulissantes',
      description: 'Maintenance et réparation des systèmes coulissants',
      features: ['Rails', 'Roulettes', 'Serrures']
    },
    {
      icon: 'ri-layout-grid-line',
      title: 'Volets Roulants',
      description: 'Intervention sur volets manuels et motorisés',
      features: ['Moteurs', 'Manivelles', 'Lames']
    },
    {
      icon: 'ri-stack-line',
      title: 'Double Vitrage',
      description: 'Remplacement et réparation de vitrages',
      features: ['Vitres', 'Joints', 'Parcloses']
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-teal-100 text-teal-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-service-fill mr-2"></i>
            Services Complets
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Une Solution pour Chaque Type de Menuiserie
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            De la simple réparation au remplacement complet, nous intervenons sur tous les éléments de vos châssis
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all border border-gray-100">
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-xl mb-4">
                <i className={`${service.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-sm text-gray-600 mb-4">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-teal-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Visual Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* Left - Content */}
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
              Des Interventions Complètes et Professionnelles
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed">
              Que ce soit pour une simple réparation de mécanisme ou un remplacement complet de vitrage, 
              nos techniciens disposent de l'expertise et du matériel nécessaire pour intervenir efficacement.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-checkbox-circle-fill text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Diagnostic Complet</h4>
                  <p className="text-sm text-gray-600">Analyse détaillée de tous les éléments de votre menuiserie</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-tools-fill text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Réparation sur Place</h4>
                  <p className="text-sm text-gray-600">90% des interventions résolues dès le premier passage</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className="ri-shield-check-fill text-xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 mb-1">Garantie 2 Ans</h4>
                  <p className="text-sm text-gray-600">Toutes nos pièces et interventions sont garanties</p>
                </div>
              </div>
            </div>

            <a
              href="#calculateur"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('calculateur')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center justify-center bg-teal-500 text-white px-8 py-4 rounded-lg font-semibold hover:bg-teal-600 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calculator-line text-xl mr-2"></i>
              Estimer le Coût
            </a>
          </div>

          {/* Right - Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/28b2f0cfea2bc0c5d661a2d6da322f79.jpg"
                alt="Équipement professionnel"
                className="w-full h-full object-cover"
              />
            </div>

            {/* Floating Stats */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-6 shadow-2xl">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg">
                  <i className="ri-tools-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">90%</div>
                  <div className="text-sm text-gray-600">Réparé en 1 visite</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
